// @flow

import * as React from 'react';
import type { Element } from 'react';
import { connect } from 'react-redux';
import { WayFindingControlsActions } from '@adactive/adsum-wayfindingcontrols-asia';

import LevelControls from './subComponents/LevelControls';

import './mapControls.css';

type MappedDispatchPropsType = {|
    resetMapAndWayFinding: (boolean, boolean, boolean, boolean) => void,
|};

type OwnPropsType = {|
    allFloors: [object],
    userFloor: object,
    pathDrawing: boolean,
|};

type PropsType = OwnPropsType & MappedDispatchPropsType;

class MapControls extends React.Component<PropsType> {
    onResetMapClick = () => {
        const { resetMapAndWayFinding, pathDrawing } = this.props;
        if (!pathDrawing) {
            resetMapAndWayFinding(true, true, true, true);
        }
    }

    render(): Element<'div'> {
        const {
            allFloors, userFloor, pathDrawing
        } = this.props;

        return (
            <div className="map-control-wrapper">
                <div className="reset-map-btn" onClick={this.onResetMapClick}>My Location</div>
                <div className="level-control-wrapper">
                    <LevelControls allFloors={allFloors} userFloor={userFloor} pathDrawing={pathDrawing} />
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch: *): MappedDispatchPropsType => ({
    resetMapAndWayFinding: (reset, resetMap, resetMapAnimatedOption, resetWayfinding) => {
        dispatch(WayFindingControlsActions.resetMapAndWayFinding(
            reset,
            resetMap,
            resetMapAnimatedOption,
            resetWayfinding
        ));
    },
});

export default connect(
    null,
    mapDispatchToProps
)(MapControls);



// WEBPACK FOOTER //
// ./src/components/MapControls/MapControls.js